export enum ZIndices {
  Content = 1200,
  ContentFullscreen = 1000,
  Overlay = 1100,
  OverlayFullscreen = 900,
  Toasts = 1300,
}
